import React from 'react';

import SalonFlag from 'components/core/SalonFlag.component';

const WhenSalonFlag = ({ name, disabled, missing, children }) => {
  if (missing) {
    return (
      <SalonFlag name={name}>
        <SalonFlag.IfMissing>{children}</SalonFlag.IfMissing>
      </SalonFlag>
    );
  }

  if (disabled) {
    return (
      <SalonFlag name={name}>
        <SalonFlag.IfDisabled>{children}</SalonFlag.IfDisabled>
      </SalonFlag>
    );
  }

  return (
    <SalonFlag name={name}>
      <SalonFlag.IfEnabled>{children}</SalonFlag.IfEnabled>
    </SalonFlag>
  );
};

export default WhenSalonFlag;
